import type { ChargeName } from './charge.ts'

export const MEXICAN_TAX_CHARGES: Array<{ name: ChargeName; rate: number }> = [
  { name: 'iva', rate: 0.16 },
]
